module.exports = __webpack_public_path__ + "img/avatar6.8b699c88.png";